<template>
  <RadioGroup
    v-model="plan"
    class="w-full"
    @update:model-value="updateVariantSelectParams({ type: plan })"
  >
    <div class="flex flex-col gap-2 w-full select-none">
      <div class="flex flex-col items-start lg:flex-row gap-2">
        <RadioGroupOption
          v-slot="{ active, checked }"
          value="subscription"
          as="template"
        >
          <div class="flex-1 w-full basis-1/2">
            <button
              data-gtm-action="select plan"
              data-gtm-label="subscription"
              :class="(active || checked) && 'selected'"
              class="box-button w-full shadow-md"
            >
              <div class="flex justify-between gap-2">
                <span class="button-tag button-tag-top">
                  <template v-if="savingsMessage">
                    {{ savingsMessage }}
                  </template>
                  <template v-else>
                    {{ $t('products.save_on_your_first_order', { percentage: pricing.firstOrderDiscountPercent }) }}
                  </template>
                </span>
                <h2>
                  <del
                    :aria-label="`Normally ${formatCents(pricing.onetimeCents)}`"
                    class="text-gray-400 mr-1"
                  >
                    {{ formatCents(pricing.onetimeCents) }}
                  </del>
                  {{ formatCents(pricing.firstOrderCents) }}
                  {{ $t('bundler.subscribe_and_save') }}
                </h2>
              </div>
            </button>
            <SubscriptionPricingCheckmarks />
          </div>
        </RadioGroupOption>
        <RadioGroupOption
          v-slot="{ active, checked }"
          value="onetime"
          as="template"
        >
          <button
            data-gtm-action="select plan"
            data-gtm-label="onetime"
            :class="(active || checked) && 'selected'"
            class="box-button basis-1/2 w-full"
          >
            <div class="flex justify-between gap-2">
              <h2>
                {{ formatCents(pricing.onetimeCents) }}
                {{ $t('bundler.one_time_purchase') }}
              </h2>
            </div>
          </button>
        </RadioGroupOption>
      </div>
    </div>
  </RadioGroup>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { formatCents } from '@/utils'
import { useBundleStore, useReferralStore, useSpecialDiscountStore } from '@/stores'
import { RadioGroup, RadioGroupOption } from '@headlessui/vue'
import SubscriptionPricingCheckmarks from '@/components/shared/subscription-pricing-checkmarks.vue'
import { updateVariantSelectParams } from '@/services/bundle-url-params'

const bundleStore = useBundleStore()
const referralStore = useReferralStore()
const discountStore = useSpecialDiscountStore()

const { plan, selectedPricing: pricing } = storeToRefs(bundleStore)
const { hasReferral } = storeToRefs(referralStore)

const canUseReferral = computed(() => hasReferral.value && !discountStore.activeDiscount)

const savingsMessage = computed(() => {
  if (canUseReferral.value) {
    return `YOU'RE SAVING ${formatCents(pricing.value.firstSavings)}`
  }

  return null
})
</script>

<style>
@reference 'tailwindcss';

.plans-as-rows .md\:flex-row {
  @apply flex-col;
}
</style>
